/* 
3	DME
12	Physical Therapy
18	Specialist OV-Professional Services
27	OV_DxLab_Sx(Office)
38	PT_DME
40	PT_OT_ST
*/
const pverifyServiceTypeMap = [
  {
    value: "03",
    label: "DME - 03"
  },
  {
    value: "12",
    label: "Physical Therapy - 12"
  },
  {
    value: "18",
    label: "Specialist OV-Professional Services - 18"
  },
  {
    value: "27",
    label: "OV_DxLab_Sx(Office) - 27"
  },
  {
    value: "38",
    label: "PT_DME - 38"
  },
  {
    value: "40",
    label: "PT_OT_ST - 40"
  },
];



// Service Type Code = 98 (Professional (Physician) Visit - Office)

// Service Type Code = AL (Vision (Optometry))

// Service Type Code = MH (Mental Health)

// Service Type Code = UC (Urgent Care)
const availityServiceTypeMap = [
  {
    value: "30",
    label: "HBPC - 30"
  },
  {
    value: "33",
    label: "Chiropractic - 33"
  },
  {
    value: "35",
    label: "Dental Care - 35"
  },
  {
    value: "86",
    label: "Emergency Services - 86"
  },
  {
    value: "88",
    label: "Pharmacy - 88"
  },

];



const locationMap = [
  {
    value: "virginia",
    label: "Virginia"
  },
  {
    value: "texas",
    label: "Texas"
  },
  {
    value: "california",
    label: "California"
  },
]

const serviceTypeMap = (source: 'pverify' | 'availity') => source === 'pverify' ? pverifyServiceTypeMap : availityServiceTypeMap

export { pverifyServiceTypeMap, availityServiceTypeMap, serviceTypeMap, locationMap, };